var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolsButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m3.536 15.217-3.535.707.707-3.535zM14.143 4.609v.001l-9.9 9.9-2.828-2.828 9.9-9.9zM2.829 11.681l1.414 1.414L12.73 4.61l-1.414-1.414zm9.192-10.606a2 2 0 0 1 2.83 0l.136.151a2 2 0 0 1-.136 2.677z"
})));
export default SvgToolsButton;